import { DefaultButton, LangBlockWrapper, TableSortWrapper } from "../styles";
import { LangTitleBox } from "../../../components/LangTitleBox/LangTitleBox";
import { ProjectEditPageGridRow } from "../../projectEdit/styles";
import {ProjectEditPageGridInput, ProjectEditPageGridList} from "../../../../_deziiign/books/pages/BookEdit/styles";
import {Colors, CommonInput, CommonLabel, FlexBox, INPUT_TYPES, useToasts} from "@brg/ui";
import { ReactComponent as PlusSvg } from "../../projectEdit/close.svg";
import { JustTable } from "../../../../_competition/components/style";
import SortableList, { SortableItem, SortableKnob } from "react-easy-sort";
import { Lang } from "@brg/api";
import { ReactComponent as DottedIcon } from "../handle.svg";
import { Input } from "@brg/input";
import EditIcon24 from "../../../icons/EditIcon24";
import { BasketIcon } from "../../projectEdit/BasketIcon";
import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ITeamTab } from "./TeamTabEdit";
import { createEmptyLangObject } from "../../../components/__ADDONS__/__SAFEAPI__/Empty";
import { ITeamFilterModel } from "./TeamFilterEditView";
import { arrayMoveImmutable } from 'shared/utils/arrayMove';
import {filterMaxLength, IModalSettings, setTextByLang, textAllowed} from "../TeamEdit";
import {LangObject} from "@brg/api/dist/api-core/utils/lang-utils";
import styled, {useTheme} from "styled-components";
import {StyledInput, StyledLinkInput} from "../../../components/LangTitleBox/styles";
import {TabType} from "./TeamTabsBlock";
import {TextAreaLengthCounter} from "./TextAreaLengthCounter";

export interface ITeamTopLink {
  name: LangObject[];
  link: string;
}
export interface ITeamTopLinkTranslated {
  name: string;
  link: string;
}

interface TeamTabsProps {
  topLinks: ITeamTopLink[];
  setTopLinks: (tabs: ITeamTopLink[]) => void;
  isMobile?: boolean;
  isS?: boolean;
  is1280?: boolean;
  onModalStateChange?: (show: boolean, settings: IModalSettings | null) => void;
  onLocalLangChange: (arr: any[], lang: string, callback: (test: any[]) => void) => void
}

const TopLinkWrapper = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
`

const TeamTopLinksBlock = ({
  topLinks = [],
  isMobile,
  isS,
  is1280,
  onLocalLangChange,
  onModalStateChange,
  setTopLinks,
}: TeamTabsProps) => {
  const { t, i18n: { language } } = useTranslation();
  const currentLang = topLinks?.find((topLink) => topLink?.currentLang)?.currentLang || 'ru';
  const theme = useTheme()
  const toasts = useToasts();

  const onTopLinkSortEnd = useCallback((oldIndex: number, newIndex: number) => {
    const newTopLinks = arrayMoveImmutable(topLinks, oldIndex, newIndex)
    setTopLinks(newTopLinks);
  }, [topLinks]);

  const onTopLinkChangeLink = useCallback((newLink: string, index: number) => {

    const newTopLinks = [...topLinks];
    newTopLinks[index] = {...newTopLinks[index], link: newLink};
    setTopLinks(newTopLinks)
  }, [topLinks]);

  const onTopLinkChangeName = useCallback((newName: any, index: number) => {

    const newTopLinks = [...topLinks];
    newTopLinks[index] = {...newTopLinks[index], name: newName};
    setTopLinks(newTopLinks)
  }, [topLinks]);

  const onTopLinkDelete = useCallback((index: number) => {
    const confirmation = window.confirm('Вы действительно хотите удалить вкладку?');
    if (confirmation) {
      const newTopLinks = [...topLinks];
      newTopLinks.splice(index, 1);
      setTopLinks(newTopLinks);
    }
  }, [topLinks]);

  const onTopLinkAdd = useCallback(() => {
    const newTopLinks = [...topLinks];
    newTopLinks.push({
      name: createEmptyLangObject('', ['ru', 'en']),
      link: ''
    });
    setTopLinks(newTopLinks);
  }, [topLinks]);

  const handlePathBlur = (index: number) => {
    if (topLinks[index]?.link && !topLinks[index]?.link.startsWith('https://')) {
      onTopLinkChangeLink(`https://${topLinks[index]?.link}`, index)
    }
  };

  return (
    <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction={is1280 ? 'column' : 'row'}
                      directionMobile={isMobile ? 'column' : 'row'}>
      <CommonLabel 
        label={t('teams.adminPage.fields.top_links')}
        useLangSwitcher={!!topLinks?.length}
        onLanguageChange={() => onLocalLangChange(topLinks, currentLang, (val) => setTopLinks(val))}
        lang={currentLang}
      />
      <ProjectEditPageGridRow directionMobile={!!topLinks?.length ? 'column' : 'row'} isTeamEdit style={{width:"100%"}}>
        <ProjectEditPageGridList direction={'column'} directionMobile="column" isTeamEdit>
          {!topLinks?.length && (
            <FlexBox style={{ marginBottom: !topLinks?.length ? 0 : 24 }}>
              <DefaultButton wh={195} whMob={195} onClick={() => onTopLinkAdd()}>
                <PlusSvg/>
                {t('teams.adminPage.buttons.add')}
              </DefaultButton>
            </FlexBox>
          )}
          {!!topLinks?.length && (
              <SortableList as={'div'} onSortEnd={onTopLinkSortEnd}>
                <FlexBox gy={24} direction="column" directionMobile="column">
                  {topLinks.map((topLink, index) => {
                    // const name = Lang(tab.name, currentLang) || t('teams.adminPage.buttons.empty');
                    return (
                        <SortableItem key={"team-tab-sortable_" + index}>
                          <TopLinkWrapper>
                            {!isS && <SortableKnob>
                              <div style={{ cursor: 'grab', backgroundColor: 'transparent' }}>
                                <DottedIcon/>
                              </div>
                            </SortableKnob>}
                            <FlexBox gy={8} direction="column" directionMobile="column" width="100%">
                              <FlexBox justify="space-between">
                                <span className="small-caption"
                                      style={{color: Colors.galBlack100, fontWeight: 600}}>{t('teams.adminPage.top_links.link_number', {number: index + 1})}</span>
                                <FlexBox gx={8}>
                                  {isS && <SortableKnob>
                                    <div style={{cursor: 'grab', backgroundColor: 'transparent'}}>
                                      <DottedIcon/>
                                    </div>
                                  </SortableKnob>}
                                  <FlexBox offsetLeftMobile={8}>
                                    <BasketIcon fill={'#838382'} onClick={() => onTopLinkDelete(index)}/>
                                  </FlexBox>
                                </FlexBox>
                              </FlexBox>
                              <FlexBox gy={16} direction="column" directionMobile="column">
                                <FlexBox gy={isS ? 8 : 12} direction="column" directionMobile="column">
                                  <span className="small-caption"
                                        style={{color: 'rgba(144, 144, 144, 1)'}}>{t('teams.adminPage.top_links.name')}</span>
                                        <CommonInput 
                                          type={INPUT_TYPES.textarea}
                                          maxLength={170}
                                          minHeight={68}
                                          value={Lang(topLink.name, currentLang)}
                                          onChange={(value: any) => textAllowed(filterMaxLength(value, 170, toasts, t), (val) => onTopLinkChangeName(setTextByLang(topLink.name, currentLang, val), index))}
                                        />
                                </FlexBox>
                                <FlexBox gy={isS ? 8 : 12} direction="column" directionMobile="column">
                                  <span className="small-caption"
                                      style={{color: 'rgba(144, 144, 144, 1)'}}>{t('teams.adminPage.top_links.link')}</span>
                                  <StyledLinkInput
                                      className={'styled-input'}
                                      onChange={(ev) => onTopLinkChangeLink(ev.target.value, index)}
                                      value={topLink?.link}
                                      placeholder={t('teams.adminPage.top_links.link_placeholder')}
                                      onBlur={() => handlePathBlur(index)}
                                      style={{
                                        color: theme.designerEdit.inputs.color,
                                      }}
                                  />
                                </FlexBox>
                              </FlexBox>
                            </FlexBox>
                          </TopLinkWrapper>
                        </SortableItem>
                    );
                  })}
                </FlexBox>
              </SortableList>
          )}
          {!!topLinks?.length && (
            <FlexBox style={{ marginTop: !topLinks?.length ? 0 : 24 }}>
              <DefaultButton wh={195} whMob={195} onClick={() => onTopLinkAdd()}>
                <PlusSvg/>
                {t('teams.adminPage.buttons.add')}
              </DefaultButton>
            </FlexBox>
          )}

        </ProjectEditPageGridList>
      </ProjectEditPageGridRow>
    </LangBlockWrapper>
  )
};

export default TeamTopLinksBlock;import { DefaultButton, LangBlockWrapper, TableSortWrapper } from "../styles";
import { LangTitleBox } from "../../../components/LangTitleBox/LangTitleBox";
import { ProjectEditPageGridRow } from "../../projectEdit/styles";
import {ProjectEditPageGridInput, ProjectEditPageGridList} from "../../../../_deziiign/books/pages/BookEdit/styles";
import {Colors, CommonInput, CommonLabel, FlexBox, INPUT_TYPES, useToasts} from "@brg/ui";
import { ReactComponent as PlusSvg } from "../../projectEdit/close.svg";
import { JustTable } from "../../../../_competition/components/style";
import SortableList, { SortableItem, SortableKnob } from "react-easy-sort";
import { Lang } from "@brg/api";
import { ReactComponent as DottedIcon } from "../handle.svg";
import { Input } from "@brg/input";
import EditIcon24 from "../../../icons/EditIcon24";
import { BasketIcon } from "../../projectEdit/BasketIcon";
import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ITeamTab } from "./TeamTabEdit";
import { createEmptyLangObject } from "../../../components/__ADDONS__/__SAFEAPI__/Empty";
import { ITeamFilterModel } from "./TeamFilterEditView";
import { arrayMoveImmutable } from 'shared/utils/arrayMove';
import {filterMaxLength, IModalSettings, setTextByLang, textAllowed} from "../TeamEdit";
import {LangObject} from "@brg/api/dist/api-core/utils/lang-utils";
import styled, {useTheme} from "styled-components";
import {StyledInput, StyledLinkInput} from "../../../components/LangTitleBox/styles";
import {TabType} from "./TeamTabsBlock";
import {TextAreaLengthCounter} from "./TextAreaLengthCounter";

export interface ITeamTopLink {
  name: LangObject[];
  link: string;
}
export interface ITeamTopLinkTranslated {
  name: string;
  link: string;
}

interface TeamTabsProps {
  topLinks: ITeamTopLink[];
  setTopLinks: (tabs: ITeamTopLink[]) => void;
  isMobile?: boolean;
  isS?: boolean;
  is1280?: boolean;
  onModalStateChange?: (show: boolean, settings: IModalSettings | null) => void;
  onLocalLangChange: (arr: any[], lang: string, callback: (test: any[]) => void) => void
}

const TopLinkWrapper = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
`

const TeamTopLinksBlock = ({
  topLinks = [],
  isMobile,
  isS,
  is1280,
  onLocalLangChange,
  onModalStateChange,
  setTopLinks,
}: TeamTabsProps) => {
  const { t, i18n: { language } } = useTranslation();
  const currentLang = topLinks?.find((topLink) => topLink?.currentLang)?.currentLang || 'ru';
  const theme = useTheme()
  const toasts = useToasts();

  const onTopLinkSortEnd = useCallback((oldIndex: number, newIndex: number) => {
    const newTopLinks = arrayMoveImmutable(topLinks, oldIndex, newIndex)
    setTopLinks(newTopLinks);
  }, [topLinks]);

  const onTopLinkChangeLink = useCallback((newLink: string, index: number) => {

    const newTopLinks = [...topLinks];
    newTopLinks[index] = {...newTopLinks[index], link: newLink};
    setTopLinks(newTopLinks)
  }, [topLinks]);

  const onTopLinkChangeName = useCallback((newName: any, index: number) => {

    const newTopLinks = [...topLinks];
    newTopLinks[index] = {...newTopLinks[index], name: newName};
    setTopLinks(newTopLinks)
  }, [topLinks]);

  const onTopLinkDelete = useCallback((index: number) => {
    const confirmation = window.confirm('Вы действительно хотите удалить вкладку?');
    if (confirmation) {
      const newTopLinks = [...topLinks];
      newTopLinks.splice(index, 1);
      setTopLinks(newTopLinks);
    }
  }, [topLinks]);

  const onTopLinkAdd = useCallback(() => {
    const newTopLinks = [...topLinks];
    newTopLinks.push({
      name: createEmptyLangObject('', ['ru', 'en']),
      link: ''
    });
    setTopLinks(newTopLinks);
  }, [topLinks]);

  const handlePathBlur = (index: number) => {
    if (topLinks[index]?.link && !topLinks[index]?.link.startsWith('https://')) {
      onTopLinkChangeLink(`https://${topLinks[index]?.link}`, index)
    }
  };

  return (
    <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction={is1280 ? 'column' : 'row'}
                      directionMobile={isMobile ? 'column' : 'row'}>
      <CommonLabel 
        label={t('teams.adminPage.fields.top_links')}
        useLangSwitcher={!!topLinks?.length}
        onLanguageChange={() => onLocalLangChange(topLinks, currentLang, (val) => setTopLinks(val))}
        lang={currentLang}
      />
      <ProjectEditPageGridRow directionMobile={!!topLinks?.length ? 'column' : 'row'} isTeamEdit style={{width:"100%"}}>
        <ProjectEditPageGridList direction={'column'} directionMobile="column" isTeamEdit>
          {!topLinks?.length && (
            <FlexBox style={{ marginBottom: !topLinks?.length ? 0 : 24 }}>
              <DefaultButton wh={195} whMob={195} onClick={() => onTopLinkAdd()}>
                <PlusSvg/>
                {t('teams.adminPage.buttons.add')}
              </DefaultButton>
            </FlexBox>
          )}
          {!!topLinks?.length && (
              <SortableList as={'div'} onSortEnd={onTopLinkSortEnd}>
                <FlexBox gy={24} direction="column" directionMobile="column">
                  {topLinks.map((topLink, index) => {
                    // const name = Lang(tab.name, currentLang) || t('teams.adminPage.buttons.empty');
                    return (
                        <SortableItem key={"team-tab-sortable_" + index}>
                          <TopLinkWrapper>
                            {!isS && <SortableKnob>
                              <div style={{ cursor: 'grab', backgroundColor: 'transparent' }}>
                                <DottedIcon/>
                              </div>
                            </SortableKnob>}
                            <FlexBox gy={8} direction="column" directionMobile="column" width="100%">
                              <FlexBox justify="space-between">
                                <span className="small-caption"
                                      style={{color: Colors.galBlack100, fontWeight: 600}}>{t('teams.adminPage.top_links.link_number', {number: index + 1})}</span>
                                <FlexBox gx={8}>
                                  {isS && <SortableKnob>
                                    <div style={{cursor: 'grab', backgroundColor: 'transparent'}}>
                                      <DottedIcon/>
                                    </div>
                                  </SortableKnob>}
                                  <FlexBox offsetLeftMobile={8}>
                                    <BasketIcon fill={'#838382'} onClick={() => onTopLinkDelete(index)}/>
                                  </FlexBox>
                                </FlexBox>
                              </FlexBox>
                              <FlexBox gy={16} direction="column" directionMobile="column">
                                <FlexBox gy={isS ? 8 : 12} direction="column" directionMobile="column">
                                  <span className="small-caption"
                                        style={{color: 'rgba(144, 144, 144, 1)'}}>{t('teams.adminPage.top_links.name')}</span>
                                        <CommonInput 
                                          type={INPUT_TYPES.textarea}
                                          maxLength={170}
                                          minHeight={68}
                                          value={Lang(topLink.name, currentLang)}
                                          onChange={(value: any) => textAllowed(filterMaxLength(value, 170, toasts, t), (val) => onTopLinkChangeName(setTextByLang(topLink.name, currentLang, val), index))}
                                        />
                                </FlexBox>
                                <FlexBox gy={isS ? 8 : 12} direction="column" directionMobile="column">
                                  <span className="small-caption"
                                      style={{color: 'rgba(144, 144, 144, 1)'}}>{t('teams.adminPage.top_links.link')}</span>
                                  <StyledLinkInput
                                      className={'styled-input'}
                                      onChange={(ev) => onTopLinkChangeLink(ev.target.value, index)}
                                      value={topLink?.link}
                                      placeholder={t('teams.adminPage.top_links.link_placeholder')}
                                      onBlur={() => handlePathBlur(index)}
                                      style={{
                                        color: theme.designerEdit.inputs.color,
                                      }}
                                  />
                                </FlexBox>
                              </FlexBox>
                            </FlexBox>
                          </TopLinkWrapper>
                        </SortableItem>
                    );
                  })}
                </FlexBox>
              </SortableList>
          )}
          {!!topLinks?.length && (
            <FlexBox style={{ marginTop: !topLinks?.length ? 0 : 24 }}>
              <DefaultButton wh={195} whMob={195} onClick={() => onTopLinkAdd()}>
                <PlusSvg/>
                {t('teams.adminPage.buttons.add')}
              </DefaultButton>
            </FlexBox>
          )}

        </ProjectEditPageGridList>
      </ProjectEditPageGridRow>
    </LangBlockWrapper>
  )
};

export default TeamTopLinksBlock;